import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { colors } from '../../../constants/colors';

const TopQueriesChart = ({ data = [], isLoading = false }) => {
  // Handle different possible data structures from API
  const chartData = data.map((item, index) => ({
    query: (item.query || item.text || item.question || 'Unknown Query')?.substring(0, 30) + ((item.query || item.text || item.question || 'Unknown Query')?.length > 30 ? '...' : ''),
    count: item.count || item.frequency || item.total || 0,
    fullQuery: item.query || item.text || item.question || 'Unknown Query'
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div style={{
          backgroundColor: colors.background.primary,
          border: `1px solid ${colors.border}`,
          borderRadius: '6px',
          padding: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <p style={{ 
            margin: '0 0 4px 0', 
            fontWeight: '600', 
            color: colors.text.primary,
            fontSize: '14px'
          }}>
            Query: {data.fullQuery}
          </p>
          <p style={{ 
            margin: 0, 
            color: colors.text.secondary,
            fontSize: '12px'
          }}>
            Count: {data.count}
          </p>
        </div>
      );
    }
    return null;
  };

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
        color: colors.text.secondary
      }}>
        Loading...
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
        color: colors.text.secondary
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📊</div>
        <p style={{ margin: 0, fontSize: '16px' }}>No query data available</p>
        <p style={{ margin: '4px 0 0 0', fontSize: '14px' }}>Start using the system to see analytics</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={colors.border} />
        <XAxis 
          dataKey="query" 
          angle={-45}
          textAnchor="end"
          height={80}
          fontSize={12}
          stroke={colors.text.secondary}
        />
        <YAxis 
          stroke={colors.text.secondary}
          fontSize={12}
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar 
          dataKey="count" 
          fill={colors.primary}
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TopQueriesChart;

